import EmployeeLayout from '../../components/layout/EmployeeLayout';
import EventsListView from '../../components/EventsListView';

export default function EmployeeEventsListPage() {
  return (
    <EmployeeLayout>
      <EventsListView title="Events List" basePath="/employee/events-list" />
    </EmployeeLayout>
  );
}
